import { SVGProps } from "react";

const ProfileUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={46}
    height={46}
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.25 42.1663H28.75C38.3334 42.1663 42.1667 38.333 42.1667 28.7497V17.2497C42.1667 7.66634 38.3334 3.83301 28.75 3.83301H17.25C7.66671 3.83301 3.83337 7.66634 3.83337 17.2497V28.7497C3.83337 38.333 7.66671 42.1663 17.25 42.1663Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 19.1667C19.3671 19.1667 21.0833 17.4504 21.0833 15.3333C21.0833 13.2162 19.3671 11.5 17.25 11.5C15.1329 11.5 13.4166 13.2162 13.4166 15.3333C13.4166 17.4504 15.1329 19.1667 17.25 19.1667Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.11755 36.3207L14.5667 29.9766C16.0809 28.9607 18.2659 29.0757 19.6267 30.2449L20.2592 30.8007C21.7542 32.0849 24.1692 32.0849 25.6642 30.8007L33.6376 23.9582C35.1326 22.6741 37.5476 22.6741 39.0426 23.9582L42.1667 26.6416"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ProfileUpload;
